import { Injectable } from '@angular/core';
import { MetroToastService } from './metro-toast.service';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  constructor(private toast: MetroToastService) {}

  private format(message: string, params: string[] = []) {
    return params.reduce((acc, p, i) => acc.replace(`{${i}}`, p), message);
  }

  showToast(
    title: string,
    message: string,
    type: 'info' | 'success' | 'warning' | 'error' = 'info',
    params: string[] = [],
    duration = 3000,
  ) {
    const formattedMessage = this.format(message, params);
    const formattedTitle = this.format(title, params);

    switch (type) {
      case 'success':
        return this.toast.success(formattedMessage, formattedTitle, { life: duration });
      case 'warning':
        return this.toast.warn(formattedMessage, formattedTitle, { life: duration });
      case 'error':
        return this.toast.error(formattedMessage, formattedTitle, { life: duration });
      default:
        return this.toast.info(formattedMessage, formattedTitle, { life: duration });
    }
  }

  success(title: string, message: string, params: string[] = [], duration = 3000) {
    return this.showToast(title, message, 'success', params, duration);
  }

  error(title: string, message: string, params: string[] = [], duration = 3000) {
    return this.showToast(title, message, 'error', params, duration);
  }

  info(title: string, message: string, params: string[] = [], duration = 3000) {
    return this.showToast(title, message, 'info', params, duration);
  }

  warning(title: string, message: string, params: string[] = [], duration = 3000) {
    return this.showToast(title, message, 'warning', params, duration);
  }
}
